import { ProgressHTMLAttributes } from 'react'

import styled, { css } from 'styled-components'

import goldCheckIcon from 'assets/images/gold-check-icon.svg'

import { Color, HEADER_HEIGHT } from 'root-constants'

interface IProgressProps extends ProgressHTMLAttributes<HTMLProgressElement> {
  $pointsNumber: number
  $trackColor: string
}

type TStepProps = {
  $isActive: boolean
  $isPassed?: boolean
  $trackColor: string
}

const progressValueStyles = css`
  background-color: ${Color.GOLD_BASE};
  transition: all 0.2s ease-out;
`

export const StyledPostPaymentProgressBar = {
  Wrapper: styled.div<{ $isHeaderOverlay: boolean }>`
    margin: 0 auto;
    padding: ${({ $isHeaderOverlay }) =>
        $isHeaderOverlay ? HEADER_HEIGHT + 50 : 50}px
      0 4px;
    display: flex;
    justify-content: center;
  `,
  StepBlock: styled.div`
    position: relative;
    display: flex;
    align-items: center;
  `,
  StepBlockProgress: styled.progress<IProgressProps>`
    width: ${({ $pointsNumber }) =>
      `${(250 - 18 * ($pointsNumber + 1)) / $pointsNumber}px`};
    height: 2px;

    display: block;
    overflow: hidden;
    appearance: none;
    border: none;

    margin: 0 4px;

    &::-webkit-progress-bar {
      background: ${({ $trackColor }) => $trackColor};
    }

    &::-webkit-progress-value {
      ${progressValueStyles}
    }

    &::-moz-progress-bar {
      ${progressValueStyles}
    }

    &::-ms-fill {
      ${progressValueStyles}
    }
  `,
  Step: styled.div<TStepProps>`
    position: relative;
    width: 24px;
    height: 24px;

    border-radius: 50%;
    background: ${({ $trackColor }) => $trackColor};
    transition: background 0.2s linear;

    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    display: flex;
    justify-content: center;
    align-items: center;

    ${({ $isActive }) =>
      $isActive &&
      css`
        box-shadow: inset 0px 0px 0px 2px ${Color.GOLD_BASE};
        background: transparent;
        color: ${Color.INK_DARKEST};
      `}

    ${({ $isPassed }) =>
      $isPassed &&
      css`
        background: url(${goldCheckIcon}) center center no-repeat;
        background-size: contain;
        color: ${Color.INK_DARKEST};
      `}
  `,
  StepText: styled.span`
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);

    min-width: 68px;

    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.5px;
    white-space: pre-line;
  `,
}
